module.exports = __webpack_public_path__ + "img/receiveRedEnvelopeMaskImage.5fa7f359.png";